import { render } from "./index.vue?vue&type=template&id=218413dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=218413dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-218413dc"

export default script